import { FormaFreteItem, ServicoLogisticaReversaItem } from '../../models/vendas/forma-envio-detalhe.model';

export class FormaEnvioSalvarRequest {
  public idTipoLogistica: number = 0;
  public descricao: string = '';
  public isAtivo: boolean = true;
  public urlRastreamento: string | null = null;
  public idsDocumentosImpressaoEmbalagem: number[] = [];
  public idsDocumentosImpressaoExpedicao: number[] = [];
  public idModeloEtiqueta: number | null = null;
  public correios: FormaEnvioCorreiosRequest | null = null;
  public formasFrete: FormaFreteItem[] = [];
  public servicosLogisticaReversa: ServicoLogisticaReversaItem[] = [];
}

export class FormaEnvioCorreiosRequest {
  public possuiContrato: boolean = false;
  public idPessoaTransportador: number | null = null;
  public utilizarOutroCnpj: boolean = false;
  public usuarioCorreios: string | null = null;
  public senhaCorreios: string | null = null;
  public cnpjCorreios: string | null = null;
  public habilitarAtualizacaoAutomaticaRastreios: boolean = false;
  public utilizaDCe: boolean = false;
  public numeroCartaoPostagem: string | null = null;
  public unidadePostagem: string | null = null;
  public diretoriaRegional: string | null = null;
  public utilizarDataExpedicaoPostagem: boolean = false;
  public codigoAdministrativo: string | null = null;
  public numeroContrato: string | null = null;
  public anoContrato: string | null = null;
  public nomeCliente: string | null = null;
  public utilizarDimensoesMinimas: boolean = false;
  public agruparProdutosEmbalagem: boolean = false;
  public isMarcarMinimoValorDeclarado: boolean = false;
  public isMarcarMinimoValorDeclaradoMini: boolean = false;
  public prazoPostagemConvencional: number | null = null;
  public usuarioLogisticaReversa: string | null = null;
  public senhaLogisticaReversa: string | null = null;
  public prazoPostagemReversa: number | null = null;
}
